import React from 'react';
import { AriaLiveAnnouncer } from '../AriaLiveAnnouncer';
import { H1 } from '@amzn/atoz-web/Text';
export var PageHeader = function (_a) {
    var headingText = _a.headingText;
    return (React.createElement(AriaLiveAnnouncer, { id: "page-header" },
        React.createElement(H1, null, headingText)));
};
